import React from 'react'
import PropTypes from 'prop-types'
import { Route, Switch, Redirect } from 'react-router-dom'
import * as Views from './views'
import Layout from './Layout'
import {
  CreateNewNotificationAddendumStage,
  NEW_ADDENDUM_NOTIFICATIONS_STAGES_PLAN_SPONSOR,
  NEW_ADDENDUM_NOTIFICATIONS_STAGES,
  AccountAudience,
  ParticipantFileUploadStageNotificationServices,
  PARTICIPANT_FILE_UPLOAD_STAGES_NOTIFICATIONS,
  Path,
} from 'config/portal'
import * as Types from 'types'

const propTypes = {
  match: PropTypes.object.isRequired,
  currentUser: Types.user.isRequired,
}
const defaultProps = {}

const PARTICIPANT_JOURNEY_HEADER = 'Start notification order'

function Routes({ match: { path }, currentUser }) {
  // window.appEventData.pop()
  // var appEventData = window.appEventData || []
  // appEventData.push({
  //   event: 'Page Load Completed',
  // })
  const isPlanFiduciary =
    currentUser?.accountAudience === AccountAudience.PLAN_FIDUCIARY
  const notificationAddendumStages = isPlanFiduciary
    ? NEW_ADDENDUM_NOTIFICATIONS_STAGES_PLAN_SPONSOR
    : NEW_ADDENDUM_NOTIFICATIONS_STAGES
  return (
    <Switch>
      <Route
        path={path + '/add-new-addendum'}
        render={() => (
          <Layout
            subject="addendum"
            title={'Create new addendum'}
            stages={notificationAddendumStages}
            currentStage={CreateNewNotificationAddendumStage.agreementSelection}
          >
            <Views.AddNewAddendumView />
          </Layout>
        )}
      />
      {!isPlanFiduciary && (
        <Route
          path={path + '/review-plan-information'}
          render={() => (
            <Layout
              title={'Create new addendum'}
              subject="services agreement"
              currentStage={
                CreateNewNotificationAddendumStage.reviewPlanInformation
              }
              stages={notificationAddendumStages}
            >
              <Views.ReviewPlanInformationView />
            </Layout>
          )}
        />
      )}
      <Route
        path={path + '/review-and-submit-addendum'}
        render={() => (
          <Layout
            subject="addendum"
            title={'Create new addendum'}
            stages={notificationAddendumStages}
            currentStage={CreateNewNotificationAddendumStage.reviewAndSubmit}
          >
            <Views.ReviewAndSubmitAddendumView />
          </Layout>
        )}
      />
      <Route
        path={path + '/upload-file'}
        render={() => (
          <Layout
            title={PARTICIPANT_JOURNEY_HEADER}
            subject="participant file upload"
            currentStage={
              ParticipantFileUploadStageNotificationServices.participantFileUpload
            }
            stages={PARTICIPANT_FILE_UPLOAD_STAGES_NOTIFICATIONS}
          >
            <Views.UploadParticipantFileView />
          </Layout>
        )}
      />
      <Route
        path={path + '/plan-mapping'}
        render={() => (
          <Layout
            title={PARTICIPANT_JOURNEY_HEADER}
            subject="participant file upload"
            currentStage={
              ParticipantFileUploadStageNotificationServices.planMapping
            }
            stages={PARTICIPANT_FILE_UPLOAD_STAGES_NOTIFICATIONS}
          >
            <Views.PlanMappingView />
          </Layout>
        )}
      />
      <Route
        path={path + '/plan-confirmation'}
        render={() => (
          <Layout
            title={PARTICIPANT_JOURNEY_HEADER}
            subject="participant file upload"
            currentStage={
              ParticipantFileUploadStageNotificationServices.planMapping
            }
            stages={PARTICIPANT_FILE_UPLOAD_STAGES_NOTIFICATIONS}
          >
            <Views.PlanConfirmationView />
          </Layout>
        )}
      />
      <Route
        path={path + '/review-notification-materials'}
        render={() => (
          <Layout
            title={PARTICIPANT_JOURNEY_HEADER}
            subject="participant file upload"
            currentStage={
              ParticipantFileUploadStageNotificationServices.reviewMaterials
            }
            stages={PARTICIPANT_FILE_UPLOAD_STAGES_NOTIFICATIONS}
          >
            <Views.ReviewNotificationMaterialsView />
          </Layout>
        )}
      />
      <Route
        path={path + '/review-and-submit-participant-data'}
        render={() => (
          <Layout
            title={PARTICIPANT_JOURNEY_HEADER}
            subject="participant file upload"
            currentStage={
              ParticipantFileUploadStageNotificationServices.reviewAndSubmit
            }
            stages={PARTICIPANT_FILE_UPLOAD_STAGES_NOTIFICATIONS}
          >
            <Views.ReviewAndSubmitView />
          </Layout>
        )}
      />
      <Redirect path="*" to={Path.NOTIFICATIONS_HISTORY} />
    </Switch>
  )
}

Routes.propTypes = propTypes
Routes.defaultProps = defaultProps

export default Routes
